import { Textarea } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { TellescopeFormFieldBaseProps } from "../types";

export interface StringLongFieldProps extends TellescopeFormFieldBaseProps<"stringLong"> {}

export const StringLongField = ({
  title,
  value,
  onChange,
  className,
  error,
  onBlur,
  touched,
}: StringLongFieldProps) => {
  const showError = !!(error && touched);

  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        className={cn(className, showError && "border-destructive")}
        aria-invalid={showError}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
